<template>


  <div class='logs'>
    <div class="header">
      <el-form :model="state.form" size="default" label-width="100px" class="mt35 mb35">
        <!--   gutter代表 el-col之间的间距    -->
        <el-row :gutter="35">
          <el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="4" class="mb20">
            <el-form-item label="姓名">
              <el-input v-model="state.form.name" placeholder="请输入姓名" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="4" class="mb20">
            <el-form-item label="姓名">
              <el-input v-model="state.form.name" placeholder="请输入姓名" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="4" class="mb20">
            <el-form-item label="姓名">
              <el-input v-model="state.form.name" placeholder="请输入姓名" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="4" class="mb20">
            <el-form-item label="姓名">
              <el-input v-model="state.form.name" placeholder="请输入姓名" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="4" class="mb20">
            <el-form-item label="姓名">
              <el-input v-model="state.form.name" placeholder="请输入姓名" clearable></el-input>
            </el-form-item>
          </el-col>


          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" >
            <el-form-item>
              <el-button type="primary">
                <SvgIcon name="iconfont icon-biaodan" />
                更新个人信息
              </el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="content">
      <!--
        data 代表数据
        stripe 隔行有颜色
        border 添加边框
        height 表头固定
        show-header 显示表头
       -->
      <el-table
          :data="handleTableData()"
          stripe
          border
          height="100%"
          show-header
          header-align="center"
          width="100%">
        <el-table-column prop="date" label="Date" width="180" align="center" header-align="center"></el-table-column>
        <el-table-column prop="name" label="Name" width="180" align="center" header-align="center"></el-table-column>
        <el-table-column prop="address" label="Address" width="280" align="center" header-align="center"></el-table-column>
        <!--   最后一个不能添加width     -->
        <el-table-column align="center">
          <template #header>
            操作
          </template>
          <template #default="scope">
            <el-button size="small" @click="handleEdit(scope.$index, scope.row)"
            >Edit</el-button
            >
            <el-button
                size="small"
                type="danger"
                @click="handleDelete(scope.$index, scope.row)"
            >Delete</el-button
            >
          </template>
        </el-table-column>
      </el-table>


    </div>

    <div class="pagination">
      <el-pagination
          v-model:current-page="currentPage"
          v-model:page-size="pageSize"
          :page-sizes="[50, 100, 150, 200]"
          :small="small"
          :disabled="disabled"
          :background="background"
          layout="total, sizes, prev, pager, next, jumper"
          :total="400"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<style lang='scss' scoped>

.logs {
  padding: 1em;
  background-color: #F7F8FA;
  flex-direction: column;
  height: 100%;

  .header {
    background-color: #FFFFFF;
    border-radius: 2px;
    padding: 24px;
    margin-bottom: 20px;
    min-height: 100px;

  }

  .content{
    /*220 = .header(min-height + margin-bottom) + .pagination(min-height)*/
    height: calc(100% - 100px - 20px - 40px);
    overflow: auto;
  }

  .pagination{
    text-align: center;
    margin-top: 10px;
    min-height: 40px;
    width: 100%;
  }

  .el-pagination {
    text-align: center;
  }

}
</style>

<script lang="ts" setup>
import {reactive, ref, toRaw} from 'vue'
const currentPage = ref(4)
const pageSize = ref(50)
const small = ref(false)
const background = ref(true)
const disabled = ref(false)


// 定义变量内容
const state = reactive({
  form: {
    name: '',
    email: '',
    autograph: '',
    occupation: '',
    phone: '',
    sex: '',
    phone1: '',
    phone2: '',
    phone3: '',
    phone4: '',
    phone5: '',
    phone6: '',
  },
});

/*分页显示多少*/
const handleSizeChange = (val: number) => {
  console.log(`${val} items per page`)
}
/*当前第几页*/
const handleCurrentChange = (val: number) => {
  console.log(`current page: ${val}`)
}
/*新增*/
const handleAdd = () => {

}
/*编辑*/
const handleEdit = (index: number , row:object) => {
  console.log(index)
  console.log(toRaw(row))
}
/*删除*/
const handleDelete = (index: number , row:object) => {
  console.log(index)
  console.log(toRaw(row))
}
/*表单*/
const handleTableData = () => {
  return [
    {
      date: '2016-05-03',
      name: 'Tom',
      address: 'No. 189, Grove St, Los Angeles',
    },
    {
      date: '2016-05-03',
      name: 'Tom',
      address: 'No. 189, Grove St, Los Angeles',
    },
    {
      date: '2016-05-03',
      name: 'Tom',
      address: 'No. 189, Grove St, Los Angeles',
    },
    {
      date: '2016-05-03',
      name: 'Tom',
      address: 'No. 189, Grove St, Los Angeles',
    },
    {
      date: '2016-05-03',
      name: 'Tom',
      address: 'No. 189, Grove St, Los Angeles',
    },
    {
      date: '2016-05-03',
      name: 'Tom',
      address: 'No. 189, Grove St, Los Angeles',
    }
    ,{
      date: '2016-05-03',
      name: 'Tom',
      address: 'No. 189, Grove St, Los Angeles',
    },
    {
      date: '2016-05-03',
      name: 'Tom',
      address: 'No. 189, Grove St, Los Angeles',
    },
    {
      date: '2016-05-03',
      name: 'Tom',
      address: 'No. 189, Grove St, Los Angeles',
    },
    {
      date: '2016-05-03',
      name: 'Tom',
      address: 'No. 189, Grove St, Los Angeles',
    },
    {
      date: '2016-05-03',
      name: 'Tom',
      address: 'No. 189, Grove St, Los Angeles',
    },
    {
      date: '2016-05-03',
      name: 'Tom',
      address: 'No. 189, Grove St, Los Angeles',
    },{
      date: '2016-05-03',
      name: 'Tom',
      address: 'No. 189, Grove St, Los Angeles',
    },
    {
      date: '2016-05-03',
      name: 'Tom',
      address: 'No. 189, Grove St, Los Angeles',
    },
    {
      date: '2016-05-03',
      name: 'Tom',
      address: 'No. 189, Grove St, Los Angeles',
    },
    {
      date: '2016-05-03',
      name: 'Tom',
      address: 'No. 189, Grove St, Los Angeles',
    },
    {
      date: '2016-05-03',
      name: 'Tom',
      address: 'No. 189, Grove St, Los Angeles',
    },
    {
      date: '2016-05-03',
      name: 'Tom',
      address: 'No. 189, Grove St, Los Angeles',
    },
    {
      date: '2016-05-03',
      name: 'Tom',
      address: 'No. 189, Grove St, Los Angeles',
    },
    {
      date: '2016-05-03',
      name: 'Tom',
      address: 'No. 189, Grove St, Los Angeles',
    },
    {
      date: '2016-05-03',
      name: 'Tom',
      address: 'No. 189, Grove St, Los Angeles',
    },
    {
      date: '2016-05-03',
      name: 'Tom',
      address: 'No. 189, Grove St, Los Angeles',
    },
    {
      date: '2016-05-03',
      name: 'Tom',
      address: 'No. 189, Grove St, Los Angeles',
    },
    {
      date: '2016-05-03',
      name: 'Tom',
      address: 'No. 189, Grove St, Los Angeles',
    }
  ]
}
</script>